import { ReportAccessLevel } from '@/types/report_team_access';

const PERMISSION_HIERARCHY: ReportAccessLevel[] = [
  'viewer',
  'commenter',
  'editor',
  'manager',
];

export function getHighestEligiblePermission(
  eligiblePermissions: ReportAccessLevel[] | undefined,
): ReportAccessLevel {
  if (!eligiblePermissions?.length) return 'viewer';

  let highestIndex = -1;
  for (const perm of eligiblePermissions) {
    const index = PERMISSION_HIERARCHY.indexOf(perm);
    if (index > highestIndex) {
      highestIndex = index;
    }
  }
  return PERMISSION_HIERARCHY[highestIndex] ?? 'viewer';
}
